module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-3-2x-b7462c37c2aededcfbeeba676ff1d246.jpg";